/**
 * Context for nested Sequence frame offsets.
 *
 * When components are inside a <Sequence>, this context provides
 * the cumulative and relative frame offsets so hooks like
 * useCurrentFrame() can compute the local frame.
 *
 * Written from scratch for Steve.AI.
 */

import { createContext } from 'react';

/**
 * @typedef {object} SequenceContextValue
 * @property {number} cumulatedFrom - Total offset from all parent sequences
 * @property {number} relativeFrom - This sequence's own `from` prop
 * @property {number} durationInFrames - Duration of this sequence
 * @property {number} parentFrom - Parent sequence's relativeFrom
 * @property {string} id - Unique ID for this sequence
 */

export const SequenceContext = createContext(null);
